<template>
  <div class="cedar">
    <v-card class="mx-auto" max-width="344" outlined>
      <v-list-item three-line>
        <v-list-item-content>
          <div class="text-overline mb-4">AMBE RESTAURANT</div>
          <v-list-item-title class="font-weight-bold text-caption mb-1">
            Awaiting My Biggest Empire
          </v-list-item-title>
          <v-list-item-subtitle
            >It can only be better with YOU!</v-list-item-subtitle
          >
        </v-list-item-content>

        <v-list-item-avatar rounded="circle" size="80" color="grey">
          <v-img
            :src="require('../assets/ambe_logo.jpeg')"
            class="grey lighten-2"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-list-item-avatar>
      </v-list-item>

      <v-card-actions>
        <v-btn outlined rounded text small :to="{ name: 'menuAmbe' }">
          Menu
        </v-btn>

        <v-btn href="https://www.instagram.com/ambe_gh/" icon>
          <v-icon>mdi-instagram</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Ambe",
  components: {},

  data() {
    return {};
  },

  methods: {},
  watch: {
    $route() {},
  },
  mounted() {},
  computed: {},
};
</script>
